;(() => {
  const SCRIPT_ID = 'kf21-yandex-maps-api';
  const API_URL = 'https://api-maps.yandex.ru/2.1/';
  const MAP_CENTER = [55.929727, 37.515825];
  let loaderPromise = null;

  const loadYandexMaps = (apiKey = '') => {
    if (window.ymaps) {
      return Promise.resolve(window.ymaps);
    }

    if (loaderPromise) {
      return loaderPromise;
    }

    loaderPromise = new Promise((resolve, reject) => {
      const existingScript = document.getElementById(SCRIPT_ID);
      const script = existingScript || document.createElement('script');

      const handleLoad = () => {
        if (!window.ymaps) {
          loaderPromise = null;
          reject(new Error('Yandex Maps API did not initialize'));
          return;
        }

        resolve(window.ymaps);
      };
      const handleError = () => {
        loaderPromise = null;
        script.remove();
        reject(new Error('Yandex Maps API failed to load'));
      };

      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', handleError, { once: true });

      if (!existingScript) {
        const params = new URLSearchParams({ lang: 'ru_RU' });
        if (apiKey) {
          params.set('apikey', apiKey);
        }

        script.id = SCRIPT_ID;
        script.src = `${API_URL}?${params.toString()}`;
        script.async = true;
        script.referrerPolicy = 'strict-origin-when-cross-origin';
        document.head.appendChild(script);
      }
    });

    return loaderPromise;
  };

  const initializeContactsMap = () => {
    const root = document.querySelector('[data-yandex-map-root]');

    if (!root) {
      return;
    }

    const canvas = root.querySelector('[data-yandex-map-canvas]');
    const placeholder = root.querySelector('[data-yandex-map-placeholder]');
    const status = root.querySelector('[data-yandex-map-status]');
    const settingsButton = root.querySelector('[data-yandex-map-consent-open]');
    const apiKey = root.dataset.yandexMapApiKey?.trim() || '';
    let map = null;
    let isInitializing = false;

    const setStatus = (message = '', isError = false) => {
      status.textContent = message;
      status.hidden = !message;
      status.dataset.state = isError ? 'error' : 'info';
    };

    const showPlaceholder = (message = '') => {
      map?.destroy();
      map = null;
      canvas.replaceChildren();
      canvas.hidden = true;
      placeholder.hidden = false;
      root.dataset.mapState = 'blocked';
      setStatus(message);
    };

    const createMap = (ymaps) => {
      if (map) {
        return;
      }

      map = new ymaps.Map(canvas, {
        center: MAP_CENTER,
        zoom: 17,
        controls: []
      });
      map.options.set('mapAutoFocus', false);
      map.behaviors.disable(['scrollZoom']);

      const placemark = new ymaps.Placemark(
        MAP_CENTER,
        {},
        {
          iconLayout: 'default#image',
          iconImageHref: 'images/map-pin.svg',
          iconImageSize: [38, 48],
          iconImageOffset: [-19, -48]
        }
      );

      map.geoObjects.add(placemark);
      root.dataset.mapState = 'ready';
    };

    const showMap = async () => {
      const manager = window.KF21ConsentManager;
      if (!manager?.hasConsent('externalServices') || isInitializing || map) {
        return;
      }
      isInitializing = true;
      placeholder.hidden = true;
      canvas.hidden = false;
      root.dataset.mapState = 'loading';
      setStatus('Загружаем интерактивную карту…');

      try {
        const ymaps = await loadYandexMaps(apiKey);
        await new Promise((resolve) => ymaps.ready(resolve));

        if (!manager.hasConsent('externalServices')) {
          showPlaceholder();
          return;
        }

        createMap(ymaps);
        setStatus();
      } catch (error) {
        showPlaceholder(
          'Не удалось загрузить интерактивную карту. Адрес организации указан рядом.'
        );
        status.dataset.state = 'error';
      } finally {
        isInitializing = false;
      }
    };

    const applyConsent = () => {
      if (window.KF21ConsentManager?.hasConsent('externalServices')) {
        showMap();
      } else {
        showPlaceholder();
      }
    };

    settingsButton?.addEventListener('click', () => {
      window.KF21ConsentManager?.openConsentSettings({
        focusCategory: 'externalServices',
        trigger: settingsButton
      });
    });

    window.addEventListener('kf21:consent-ready', applyConsent);
    window.addEventListener('kf21:consent-changed', applyConsent);
    applyConsent();
  };

  document.addEventListener('DOMContentLoaded', initializeContactsMap, { once: true });
})();
